import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-description',
  templateUrl: './card-description.component.html',
  styleUrls: ['./card-description.component.scss']
})
export class CardDescriptionComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() html = false;

  constructor() { }

  ngOnInit() {
  }

}
